import React, {useContext, useEffect, useState} from "react"
import {auth, firebase, firestore} from "../firebase"

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({children}) {
    const [currentUser, setCurrentUser] = useState()
    const [isReady, setIsReady] = useState(false)

    //Create a new auth entry for the given email/password credential pair and username
    const signup = async (email, password, name) => {
        return auth.createUserWithEmailAndPassword(email, password).then(user => {
            user.user.updateProfile({
                displayName: name.toLowerCase()
            })
            user.user.sendEmailVerification().then(() => {
                alert("Please check your email for verification")
            })
        })
    }

    //sends an email/password credential pair and returns a user object if authenticated
    const login = async (email, password) => {
        const user = await auth.signInWithEmailAndPassword(email, password)
        await firebase.auth().currentUser.getIdToken(true)
        return user
    }

    const whitelist = (newEmail, newGroup) => {
        firestore.collection(`whitelist`).doc(newEmail).set({
            group: newGroup,
            referrer: "master"
        }).then(() => {
            alert("New user: " + newEmail + " whitelisted with group: " + newGroup);
        })
    }

    //sends the email verification link required to set up a user account
    const resendEmailVerification = async (email, password) => {
        const user = await login(email, password)
        user.user.sendEmailVerification().then(() => {
            alert("Verification resent")
        }).catch((e) =>
            alert(e.message)
        )
    }

    //delete a user's entry in our database - doesn't affect auth or whitelist entries
    const deleteUser = () => {
        const cu = firebase.auth().currentUser
        firestore.collection("users").doc(cu.uid).delete().then(() => {
            cu.delete().then(() => {
                alert("User deleted")
            })
        })
    }

    //Log out the currently authenticated user
    function logout() {
        return auth.signOut()
    }

    //
    // function resetPassword(email) {
    //     return auth.sendPasswordResetEmail(email)
    // }
    //
    // function updateEmail(email) {
    //     return currentUser.updateEmail(email)
    // }
    //
    // function updatePassword(password) {
    //     return currentUser.updatePassword(password)
    // }

    //constructor to get user data upon authentication received
    useEffect(() => {
        const initGroup = async (group) => {
            const groupDoc = await firestore.collection("groups").doc(group);
            const groupData = await groupDoc.get();
            if(!groupData.exists) {
                groupDoc.set({})
            }
        }

        //create a user entry in our database if one does not exist.
        const createUser = async (user) => {
            let first = true
            try {
                const data = await firestore.collection("users").where("email", "==", user.email).get();
                if (data.docs[0] === undefined) {
                    const whitelistData = await firestore.collection("whitelist").doc(user.email).get();
                    if (whitelistData.exists) {
                        await initGroup(whitelistData.data().group)
                        await firestore.collection(`users`).doc(user.uid).set({
                            email: user.email,
                            group: whitelistData.data().group,
                            name: user.displayName,
                            role: whitelistData.data().referrer.includes("@") ? "user" : whitelistData.data().referrer
                        })
                    } else {
                        alert("User not whitelisted")
                    }
                } else {
                    first = false
                }
            } catch (error) {
                alert("email hasn't been added to user list")
                logout()
            }
            return first
        }

        return auth.onAuthStateChanged(user => {
            if (user !== null && user !== undefined && user.emailVerified) {
                createUser(user).then()
            }
            setCurrentUser(user)
            setIsReady(true)
        })
    }, [])

    //The variables and functions that will be available in this context
    const value = {
        currentUser,
        login,
        signup,
        logout,
        resendEmailVerification,
        deleteUser,
        whitelist
        // resetPassword,
        // updateEmail,
        // updatePassword
    }

    return (
        <AuthContext.Provider value={value}>
            {isReady && children}
        </AuthContext.Provider>
    )
}
